@if (dataLoading() || dropdownsLoading()) {
  <app-progress></app-progress>
}

<div class="page-content query-stepone-page">
  <div class="container-fluid">

    <!-- Breadcrumb -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 class="mb-sm-0 font-size-18">{{ action().MenuTitle }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <a routerLink="/admin/admin-dashboard">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">{{ action().ParentMenuTitle }} New Query</li>
              <li class="breadcrumb-item">{{ action().MenuTitle }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- ═══════════════════════════════════════════════════ -->
    <!-- FORM                                                 -->
    <!-- ═══════════════════════════════════════════════════ -->
    <form [formGroup]="form" (ngSubmit)="saveDetails()" novalidate>
      <div class="row g-4">

        <!-- ─────────────────────────────────────────────── -->
        <!-- SECTION 1 · Query Source                        -->
        <!-- ─────────────────────────────────────────────── -->
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
              <div class="row">

                <div class="col-lg-3 mb-3">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <i class="bx bx-search-alt text-primary fs-5"></i>
                    <span class="fw-bold">Query Source</span>
                  </div>
                  <p class="text-muted small mb-0">
                    Specify where the query came from — e.g. B2B agency or direct source.
                  </p>
                </div>

                <div class="col-lg-9">
                  <div class="row g-3">

                    <!-- ── Agency autocomplete ── -->
                    <div class="col-sm-6">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Query Source (Agency)</mat-label>

                        <input
                          matInput
                          formControlName="AgencyName"
                          [matAutocomplete]="agencyAuto"
                          (input)="onAgencyInputChange(form.get('AgencyName')!.value)"
                          placeholder="Search or add agency…">

                        @if (form.get('AgencyName')?.value) {
                          <button mat-icon-button matSuffix type="button"
                                  (click)="clearAgency()" tabindex="-1">
                            <mat-icon>close</mat-icon>
                          </button>
                        }

                        <!--
                          ✅ KEY FIX: (optionSelected) lives on <mat-autocomplete>,
                          NOT on individual <mat-option> elements.

                          Why this works:
                          • (optionSelected) fires AFTER Angular has resolved the selection,
                            avoiding the race condition with the panel closing.
                          • We pass the entire Agency object (or the ADD_NEW sentinel) as
                            [value] on each option — no string matching needed.
                          • The handler checks the value type and routes accordingly.
                        -->
                        <mat-autocomplete
                          #agencyAuto="matAutocomplete"
                          (optionSelected)="onAgencyOptionSelected($event)">

                          <!-- Existing agencies -->
                          @for (agency of visibleAgencies; track agency.AgencyId) {
                            <mat-option [value]="agency">
                              <div class="fw-semibold">{{ agency.AgencyName }}</div>
                              <div class="text-muted small">{{ agency.CityName }}</div>
                            </mat-option>
                          }

                          <!-- Add new option — shown only when typed text has no exact match -->
@if (showAddNewOption) {
  <mat-option [value]="ADD_NEW" class="add-new-option add-option-animated">
    <div class="d-flex align-items-center gap-3">
      <mat-icon class="text-primary add-icon" style="transition: transform 0.2s ease;">add_circle</mat-icon>
      <div>
        <span class="fw-medium">Create new source</span>
        <div class="medium text-muted">"{{ form.get('AgencyName')?.value || 'Unnamed' }}"</div>
      </div>
    </div>
  </mat-option>
}

                        </mat-autocomplete>

                        @if (form.get('AgencyName')?.invalid && form.get('AgencyName')?.touched) {
                          <mat-error>Agency / query source is <strong>required</strong></mat-error>
                        }
                      </mat-form-field>

                      @if (form.get('AgencyCity')?.value) {
                        <div class="text-muted small ms-1" style="margin-top:-12px;">
                          <i class="bx bx-map-pin me-1"></i>{{ form.get('AgencyCity')?.value }}
                        </div>
                      }
                    </div>

                    <!-- Reference ID -->
                    <div class="col-sm-6">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Reference ID <span class="text-muted">(optional)</span></mat-label>
                        <input matInput formControlName="ReferenceId" placeholder="e.g. 1231231">
                        <mat-hint>A custom reference id for this query</mat-hint>
                      </mat-form-field>
                    </div>

                    <!-- Sales Team -->
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Sales Team</mat-label>
                        <mat-select formControlName="AssignedToLoginId" [compareWith]="compareById">
                          @for (staff of staffList(); track staff.StaffLoginId) {
                            <mat-option [value]="staff.StaffLoginId">
                              {{ staff.StaffName }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Tags -->
                    <div class="col-12">
                      <label class="form-label text-muted small mb-2">
                        Tags <span class="text-muted">(optional)</span>
                      </label>
                      <div class="d-flex flex-wrap gap-2">
                        @for (tag of tagList(); track tag.TagId) {
                          <span
                            class="badge border fw-normal px-3 py-2"
                            style="cursor:pointer; font-size:13px;"
                            [class.bg-primary]="isTagSelected(tag.TagId)"
                            [class.text-white]="isTagSelected(tag.TagId)"
                            [class.bg-light]="!isTagSelected(tag.TagId)"
                            [class.text-dark]="!isTagSelected(tag.TagId)"
                            (click)="toggleTag(tag.TagId)">
                            {{ tag.TagName }}
                          </span>
                        }
                        @if (tagList().length === 0 && !dropdownsLoading()) {
                          <span class="text-muted small">No tags available</span>
                        }
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ─────────────────────────────────────────────── -->
        <!-- SECTION 2 · Destination and Duration            -->
        <!-- ─────────────────────────────────────────────── -->
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
              <div class="row">

                <div class="col-lg-3 mb-3">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <i class="bx bx-map-pin text-primary fs-5"></i>
                    <span class="fw-bold">Destination and Duration</span>
                  </div>
                  <p class="text-muted small mb-0">
                    Destination, travel dates, duration, adults and children.
                  </p>
                </div>

                <div class="col-lg-9">
                  <div class="row g-3">

                    <!-- Destination -->
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Destination</mat-label>
                        <mat-select formControlName="DestinationId">
                          <mat-option [value]="0" disabled>Select a destination…</mat-option>
                          @for (dest of destinationList(); track dest.DestinationId) {
                            <mat-option [value]="dest.DestinationId">
                              {{ dest.DestinationName }}
                            </mat-option>
                          }
                        </mat-select>
                        @if (form.get('DestinationId')?.invalid && form.get('DestinationId')?.touched) {
                          <mat-error>Destination is <strong>required</strong></mat-error>
                        }
                      </mat-form-field>

                      @if (form.get('DestinationId')?.value) {
                        <div class="mt-1">
                          <span class="badge bg-primary bg-opacity-10 text-primary
                                       border border-primary px-3 py-2"
                                style="font-size:12px;">
                            ✓ {{ getDestinationName(form.get('DestinationId')!.value) }}
                          </span>
                        </div>
                      }
                    </div>

                    <!-- Start Date -->
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-70">
                        <mat-label>Start Date</mat-label>
                        <input matInput [matDatepicker]="startPicker"
                               formControlName="StartDate"
                               placeholder="e.g. April 30, 2026">
                        <mat-datepicker-toggle matIconSuffix [for]="startPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #startPicker></mat-datepicker>
                        @if (form.get('StartDate')?.invalid && form.get('StartDate')?.touched) {
                          <mat-error>Start Date is <strong>required</strong></mat-error>
                        }
                      </mat-form-field>
                    </div>

                    <!-- Nights -->
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="w-50">
                        <mat-label>No. of Nights</mat-label>
                        <input matInput type="number" formControlName="NoOfNights" min="1">
                        <mat-hint>{{ nightsLabel }}</mat-hint>
                        @if (form.get('NoOfNights')?.invalid && form.get('NoOfNights')?.touched) {
                          <mat-error>Minimum 1 night</mat-error>
                        }
                      </mat-form-field>
                    </div>

                    <!-- Adults + Children -->
                    <div class="col-12">
                      <div class="d-flex align-items-center flex-wrap gap-3">

                        <mat-form-field appearance="outline" style="width:130px;">
                          <mat-label>No. of Adults</mat-label>
                          <input matInput type="number" formControlName="NoOfAdults" min="1">
                          @if (form.get('NoOfAdults')?.invalid && form.get('NoOfAdults')?.touched) {
                            <mat-error>Min 1</mat-error>
                          }
                        </mat-form-field>

                        <ng-container formArrayName="childAgeSelections">
                          @for (ctrl of childrenFormArray.controls; track $index; let i = $index) {
                            <mat-form-field appearance="outline" style="width:90px;">
                              <mat-label>Child {{ i + 1 }}</mat-label>
                              <mat-select [formControlName]="i">
                                @for (opt of ageOptions; track opt) {
                                  <mat-option [value]="opt">{{ opt }}</mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          }
                        </ng-container>

                        <button mat-icon-button type="button" class="mb-3"
                                matTooltip="Add child" (click)="addChild()">
                          <mat-icon>add_circle_outline</mat-icon>
                        </button>

                        @if (childrenFormArray.length > 0) {
                          <button mat-icon-button type="button" class="mb-3 ms-n3"
                                  matTooltip="Remove last child" (click)="removeLastChild()">
                            <mat-icon>remove_circle_outline</mat-icon>
                          </button>
                        }

                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ─────────────────────────────────────────────── -->
        <!-- SECTION 3 · Guest Details                       -->
        <!-- ─────────────────────────────────────────────── -->
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
              <div class="row">

                <div class="col-lg-3 mb-3">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <i class="bx bx-user text-primary fs-5"></i>
                    <span class="fw-bold">
                      Guest Details
                      <span class="text-muted fw-normal">(optional)</span>
                    </span>
                  </div>
                  <p class="text-muted small mb-0">Guest name and contact number(s).</p>
                </div>

                <div class="col-lg-9">
                  <div class="row g-3">

                    <!-- Guest search (shown only after agency is selected) -->
                    <!-- @if (guestList().length > 0) {
                      <div class="col-12 mb-1">
                        <mat-form-field appearance="outline" style="max-width:320px;">
                          <mat-label>Search existing guest</mat-label>
                          <input matInput [matAutocomplete]="guestAuto"
                                 (input)="onGuestInputChange($any($event.target).value)"
                                 placeholder="Name or phone…">
                          <mat-autocomplete #guestAuto="matAutocomplete">
                            @for (guest of filteredGuests; track guest.GuestId) {
                              <mat-option [value]="guest.ContactName"
                                          (onSelectionChange)="onGuestSelected(guest)">
                                <div class="fw-semibold">{{ guest.ContactName }}</div>
                                <div class="text-muted small">{{ guest.Phone }}</div>
                              </mat-option>
                            }
                          </mat-autocomplete>
                          <mat-hint>Auto-fills fields below</mat-hint>
                        </mat-form-field>
                      </div>
                    } -->

                    <!-- Salutation -->
                    <div class="col-sm-2">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Salutation</mat-label>
                        <mat-select formControlName="Salutation">
                          <mat-option value="Mr.">Mr.</mat-option>
                          <mat-option value="Mrs.">Mrs.</mat-option>
                          <mat-option value="Ms.">Ms.</mat-option>
                          <mat-option value="Dr.">Dr.</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <!-- Name -->
                    <div class="col-sm-4">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Contact Name</mat-label>
                        <input matInput formControlName="ContactName" placeholder="Full name">
                        @if (form.get('ContactName')?.invalid && form.get('ContactName')?.touched) {
                          <mat-error>Contact name is <strong>required</strong></mat-error>
                        }
                      </mat-form-field>
                    </div>

                    <!-- Phone -->
                    <div class="col-sm-6">
                      <div class="d-flex gap-2">
                        <mat-form-field appearance="outline" style="width:115px; flex-shrink:0;">
                          <mat-label>Code</mat-label>
                          <mat-select formControlName="CountryCode">
                            @for (cc of countryCodes; track cc.code) {
                              <mat-option [value]="cc.code">{{ cc.label }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>

<mat-form-field appearance="outline" class="flex-grow-1">
  <mat-label>Phone Number</mat-label>

  <input
    matInput
    formControlName="Phone"
    type="tel"
    inputmode="numeric"
    maxlength="10"
    pattern="[0-9]*"
    (keypress)="allowOnlyNumbers($event)"
  >

  @if (form.get('Phone')?.invalid && form.get('Phone')?.touched) {
    <mat-error>Phone number is <strong>required</strong></mat-error>
  }
</mat-form-field>
                      </div>
                    </div>

                    <!-- Email -->
                    <div class="col-sm-6">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email <span class="text-muted">(optional)</span></mat-label>
                        <input matInput type="email" formControlName="Email"
                               placeholder="user@domain.com">
                        @if (form.get('Email')?.invalid && form.get('Email')?.touched) {
                          <mat-error>Enter a valid email address</mat-error>
                        }
                      </mat-form-field>
                    </div>

                    <!-- Origin City -->
                    <div class="col-sm-6">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Origin City / State</mat-label>
                        <input matInput formControlName="OriginCity"
                               placeholder="e.g. Mumbai, Maharashtra">
                      </mat-form-field>
                    </div>

                    <!-- Nationality -->
                    <div class="col-sm-6">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Nationality</mat-label>
                        <input matInput formControlName="Nationality" placeholder="e.g. Indian">
                      </mat-form-field>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ─────────────────────────────────────────────── -->
        <!-- SECTION 4 · Comments or Notes                   -->
        <!-- ─────────────────────────────────────────────── -->
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body p-4">
              <div class="row">

                <div class="col-lg-3 mb-3">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <i class="bx bx-comment-detail text-primary fs-5"></i>
                    <span class="fw-bold">Comments or Notes</span>
                  </div>
                  <p class="text-muted small mb-0">
                    Any additional notes useful for the sales process.
                  </p>
                </div>

                <div class="col-lg-9">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Comments <span class="text-muted">(optional)</span></mat-label>
                    <textarea matInput formControlName="Comments"
                              rows="4" placeholder="Enter any notes…"></textarea>
                  </mat-form-field>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Save / Cancel -->
        <div class="col-12 d-flex justify-content-center gap-3 pb-4">
         <!-- Replace the save button text: -->
<button mat-raised-button color="primary"
        type="submit"
        [disabled]="dataLoading()"
        style="min-width:140px;">
  @if (dataLoading()) {
    {{ QueryStepOneId > 0 ? 'Updating…' : 'Saving…' }}
  } @else {
    {{ QueryStepOneId > 0 ? 'Update Details' : 'Save Details' }}
  }
</button>
        </div>

      </div>
    </form>

  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════ -->
<!-- ADD AGENCY MODAL                                                -->
<!--                                                                 -->
<!-- Placed OUTSIDE <form> so its own ngModel fields don't          -->
<!-- interfere with the reactive form's validation state.            -->
<!--                                                                 -->
<!-- Controlled by showModal signal() — safe with OnPush.            -->
<!-- ═══════════════════════════════════════════════════════════════ -->
@if (showModal()) {

  <!-- Backdrop -->
  <div class="modal-backdrop fade show"
       style="z-index:1040; backdrop-filter:blur(3px);"
       (click)="closeModal()">
  </div>

  <!-- Dialog -->
  <div class="modal fade show d-block" style="z-index:1050;" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg">

        <!-- Header -->
        <div class="modal-header border-bottom px-4 py-3">
          <h5 class="modal-title fw-bold">
            <i class="bx bx-buildings me-2 text-primary"></i>
            {{ AgencyModel.AgencyId > 0 ? 'Update Source' : 'Add New Source' }}
          </h5>
          <button type="button" class="btn-close" (click)="closeModal()"></button>
        </div>

        <!-- Body -->
        <div class="modal-body p-4">
          <div class="row g-3">

            <!-- Agency Name -->
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Source / Agency Name *</mat-label>
                <input matInput
                       [(ngModel)]="AgencyModel.AgencyName"
                       [ngModelOptions]="{ standalone: true }"
                       placeholder="Enter agency name"
                       maxlength="250">
                @if (isModalSubmitted && !AgencyModel.AgencyName.trim()) {
                  <mat-error>Agency name is <strong>required</strong></mat-error>
                }
              </mat-form-field>
            </div>

            <!-- City -->
            <div class="col-sm-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>City / State</mat-label>
                <input matInput
                       [(ngModel)]="AgencyModel.CityName"
                       [ngModelOptions]="{ standalone: true }"
                       placeholder="e.g. Kolkata"
                       maxlength="150">
              </mat-form-field>
            </div>

            <!-- GSTIN -->
            <div class="col-sm-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>GSTIN Number</mat-label>
                <input matInput
                       [(ngModel)]="AgencyModel.GstinNumber"
                       [ngModelOptions]="{ standalone: true }"
                       placeholder="e.g. 22AAAAA0000A1Z5"
                       maxlength="15">
              </mat-form-field>
            </div>

            <!-- Status -->
            <div class="col-sm-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Status</mat-label>
                <mat-select [(ngModel)]="AgencyModel.Status"
                            [ngModelOptions]="{ standalone: true }">
                  @for (status of StatusList; track status.Key) {
                    <mat-option [value]="status.Key">{{ status.Value }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-top px-4 py-3">
          <p class="text-muted small me-auto mb-0">
            <i class="bx bx-info-circle me-1"></i>Fields marked * are required.
          </p>
          <button type="button" class="btn btn-outline-secondary px-4"
                  (click)="closeModal()">
            Cancel
          </button>
          <button type="button" class="btn btn-primary px-4 fw-medium"
                  [disabled]="dataLoading()"
                  (click)="saveAgency()">
            <i class="bx bx-save me-1"></i>
            {{ AgencyModel.AgencyId > 0 ? 'Update' : 'Save' }}
          </button>
        </div>

      </div>
    </div>
  </div>

}